module.exports = __webpack_public_path__ + "32bce1147213b8ce7cf62313e24da6b4.svg";